import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Bar from './Bar';
import { CloseIcon } from 'shared/Miscellaneous/Icons';
import sbManagerStyles from 'utils/globalStyles';

const Container = styled.div`
  padding: 2rem;
  position: sticky;
  position: -webkit-sticky;
  right: 0;
  margin-right: -1rem;
  bottom: 8.5rem;
  z-index: 99999;
  min-width: 40rem;
  float: right;
  .icon {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
`;
const Header = styled.div`
  display: flex;
  align-items: center;
`;
const BoldText = styled.strong`
  margin-left: 0.2rem;
`;
const InforText = styled.div`
  color: ${() => sbManagerStyles.greyMedium};
`;

const Success = ({ onClick }) => (
  <Container className="card">
    <Header>
      <BoldText>Asset(s) Uploaded</BoldText>
      <CloseIcon width={15} height={15} {...{ onClick }} />
    </Header>
    <Bar percentage={1} />
    <InforText>0 files remaining</InforText>
  </Container>
);

Success.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default Success;
